import React from 'react'
import { cn } from '@/utilities/cn'

export interface BoxProps {
  children: React.ReactNode
  className?: string
}

export const Box: React.FC<BoxProps> = ({ children, className }) => {
  return (
    <div className={cn(
      'rounded-2xl p-4 bg-primary text-white mx-auto max-w-4xl',
      className
    )}>
      {children}
    </div>
  )
}